var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyComparison48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "black",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 8.50279C21.9877 8.42942 20.4301 9.81917 18.7434 10.6924C16.4493 12.0523 14.087 13.3068 11.8386 14.7372C10.368 15.9325 9.69234 17.8559 9.84677 19.7134C9.85534 23.0066 9.82971 26.3006 9.85971 29.5934C10.0501 31.5871 11.4326 33.2792 13.2116 34.1132C16.0675 35.7523 18.9066 37.4219 21.773 39.0418C23.5951 39.8727 25.7521 39.5232 27.364 38.3991C30.2115 36.7451 33.0766 35.1204 35.913 33.4479C37.5445 32.2863 38.319 30.2431 38.1516 28.2854C38.143 24.9921 38.1687 21.6982 38.1386 18.4054C37.948 16.4118 36.5658 14.7194 34.7866 13.8857C31.9306 12.2469 29.091 10.5785 26.2248 8.95835C25.5311 8.6361 24.7605 8.50492 23.9992 8.50273M22.2058 16.7959H25.7933V31.2034H22.2058V16.7959ZM26.7202 19.9317H30.306V31.2034H26.7202V19.9317ZM17.692 25.8117H21.2788V31.2034H17.692V25.8117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyComparison48);
export default __webpack_public_path__ + "static/media/empty-comparison-48.8df6e986a8ff80e2b2f0a49b65d4f306.svg";
export { ForwardRef as ReactComponent };